import { SubmitFormDialog } from '@shared/components/dialogs/submit-form-dialog';
import { VisitForm } from './visit-form';
import { useVisitFormDialog } from './visit-form-dialog.hooks';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { validateTimeIsSelected } from './visit-form.hooks';

export const VisitFormDialog = (props: { dialogRef: React.Ref<ImperativeFormDialogRefType> }) => {
  const { methods, createVisitMutation } = useVisitFormDialog();
  const { t } = useIntlTranslations('addVisitFormDialog');

  return (
    <SubmitFormDialog
      ref={props.dialogRef}
      methods={methods}
      validate={validateTimeIsSelected}
      onSubmit={createVisitMutation}
      title={t('order')}
    >
      <VisitForm />
    </SubmitFormDialog>
  );
};
